import React from 'react';

const LoadingStyle = () => <div className="loading-style">
    <span></span>
    <span></span>
    <span></span>
</div>

export default LoadingStyle;